// extracted by css-extract-rspack-plugin
export default {"primaryText":"src-widgets-LoginSsoFirst-module__primaryText-PGEJN9","primaryButton":"src-widgets-LoginSsoFirst-module__primaryButton-vdDmWd","secondaryRow":"src-widgets-LoginSsoFirst-module__secondaryRow-vsKB6m","secondaryLink":"src-widgets-LoginSsoFirst-module__secondaryLink-a8jZKL"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"primaryText\":\"src-widgets-LoginSsoFirst-module__primaryText-PGEJN9\",\"primaryButton\":\"src-widgets-LoginSsoFirst-module__primaryButton-vdDmWd\",\"secondaryRow\":\"src-widgets-LoginSsoFirst-module__secondaryRow-vsKB6m\",\"secondaryLink\":\"src-widgets-LoginSsoFirst-module__secondaryLink-a8jZKL\"}";
        // 1788963435381
        var cssReload = require("../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  